import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  description: function description(state) {
    return state.description;
  },
  products: function products(state) {
    return state.products;
  },
  tpl: function tpl(state) {
    return state.tpl;
  },
  productsCount: function productsCount(state) {
    return state.total;
  },
  productsPerPage: function productsPerPage(state) {
    return state.productsPerPage;
  }
};